<template>
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 20.327"
  >
    <g fill="none" stroke-miterlimit="10">
      <path
        d="M7.5 20.327S15 11.642 15 7.5a7.5 7.5 0 0 0-15 0c0 4.142 7.5 12.827 7.5 12.827Z"
      />
      <path
        d="M7.5 17.163a63.17 63.17 0 0 0 2.11-2.84C12.754 9.81 13 7.96 13 7.5 13 4.467 10.533 2 7.5 2A5.506 5.506 0 0 0 2 7.5c0 .458.243 2.303 3.372 6.796A63.067 63.067 0 0 0 7.5 17.163m0 3.164S0 11.642 0 7.5a7.5 7.5 0 1 1 15 0c0 4.142-7.5 12.827-7.5 12.827Z"
        fill="currentColor"
      />
    </g>
    <circle
      data-name="Oval"
      cx="2.5"
      cy="2.5"
      r="2.5"
      transform="translate(5 5)"
      fill="currentColor"
    />
  </svg>
</template>
